<!-- 平台课程类目设置-五育类/素质类 -->
<template>
  <div class="index">
    <div class="title">
      <div class="span1">
        <span>{{ $route.name }}</span>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        row-key="categoryId"
        border
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column label="类目名称" width="250" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              style="margin-left: -10%; width: 90%"
              v-model="scope.row.categoryName"
              v-if="scope.row.isAdd"
              placeholder="请输入分类"
              maxlength="15"
              >{{ scope.row.categoryName }}
            </el-input>
            <span v-if="!scope.row.isAdd">{{ scope.row.categoryName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="hierarchy"
          label="层级"
          width="180"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="numberCourse"
          label="课程数"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="sort" label="排序" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              style="margin-left: -10%; width: 90%"
              v-model="scope.row.sort"
              v-if="scope.row.isSort"
              placeholder="请输入分类"
              maxlength="15"
              >{{ scope.row.sort }}
            </el-input>
            <span v-if="!scope.row.isSort">{{ scope.row.sort }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="right"
          label="操作"
          fixed="right"
          width="200px"
        >
          <template slot-scope="scope">
            <div v-if="!scope.row.isAdd && !scope.row.isSort">
              <el-button
                type="text"
                size="small"
                @click="addCategory(scope.row)"
                v-if="scope.row.hierarchy !== 3"
                >添加子类目</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="editCategory(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="delCategory(scope.row)"
                >删除</el-button
              >
              <el-button type="text" size="small" @click="sortBtn(scope.row)"
                >排序</el-button
              >
            </div>
            <div v-if="scope.row.isAdd || scope.row.isSort">
              <el-button type="text" size="small" @click="cancelAdd(scope.row)"
                >取消</el-button
              >
              <el-button type="text" size="small" @click="confirmAdd(scope.row)"
                >保存</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-button type="primary" @click="addOne()">添加一级分类</el-button>
    </div>
  </div>
</template>
<script>
import educationApi from "@/api/education/index.js";
import util from "@/utils/util.js";

export default {
  data() {
    return {
      tableData: [],
      parentId: 0, //父级id
      addType: 0, //添加子分类：0，编辑：1
    };
  },
  watch: {
    "$route.path": function (n, o) {
      this.getDataList();
    },
  },
  methods: {
    addOne() {
      this.addType = 0;
      let query = {
        categoryId: 0,
        categoryName: "",
        isAdd: true,
        hierarchy: 1,
        sort: this.tableData.length > 1 ? this.tableData[0].sort + 1 : 1,
      };
      this.tableData.unshift(query);
      console.log(this.tableData);
    },
    async getDataList(parentId) {
      if (this.$route.path === "/education/courseManager/teachingSetting") {
        // 五育类
        // this.tableData = [
        //   {
        //     categoryId: 1,
        //     categoryName: "德育",
        //     hierarchy: 1,
        //     numberCourse: 12,
        //     sort: 1,
        //   },
        //   {
        //     categoryId: 2,
        //     categoryName: "智育",
        //     hierarchy: 1,
        //     numberCourse: 12,
        //     sort: 1,
        //   },
        //   {
        //     categoryId: 3,
        //     categoryName: "体育",
        //     hierarchy: 1,
        //     numberCourse: 12,
        //     sort: 1,
        //   },
        //   {
        //     categoryId: 4,
        //     categoryName: "美育",
        //     hierarchy: 1,
        //     numberCourse: 12,
        //     sort: 1,
        //     children: [
        //       {
        //         categoryId: 41,
        //         categoryName: "绘画",
        //         hierarchy: 2,
        //         numberCourse: 12,
        //         sort: 1,
        //       },
        //     ],
        //   },
        //   {
        //     categoryId: 5,
        //     categoryName: "劳育",
        //     hierarchy: 1,
        //     numberCourse: 12,
        //     sort: 1,
        //     children: [
        //       {
        //         categoryId: 51,
        //         categoryName: "陶艺",
        //         hierarchy: 2,
        //         numberCourse: 12,
        //         sort: 1,
        //       },
        //       {
        //         categoryId: 52,
        //         categoryName: "木艺",
        //         hierarchy: 2,
        //         numberCourse: 12,
        //         sort: 1,
        //         children: [
        //           {
        //             categoryId: 521,
        //             categoryName: "编织",
        //             hierarchy: 3,
        //             numberCourse: 12,
        //             sort: 1,
        //           },
        //           {
        //             categoryId: 522,
        //             categoryName: "美育",
        //             hierarchy: 3,
        //             numberCourse: 12,
        //             sort: 1,
        //           },
        //         ],
        //       },
        //     ],
        //   },
        // ];
        let params = {
          parentId: parentId ? parentId : 0,
        };
        let res = await educationApi.getFiveSportQuery(params);
        if (res.result == "000000") {
          // this.tableData = res.data;
          let cont = this.totree(res.data, 0);
          console.log(cont);
          this.tableData = cont;
        }
      } else {
        // 素质类
        this.tableData = [
          {
            categoryId: 1,
            categoryName: "科普教育",
            hierarchy: 1,
            numberCourse: 12,
            sort: 1,
          },
          {
            categoryId: 2,
            categoryName: "体育锻炼",
            hierarchy: 1,
            numberCourse: 12,
            sort: 1,
          },
          {
            categoryId: 3,
            categoryName: "文化艺术",
            hierarchy: 1,
            numberCourse: 12,
            sort: 1,
          },
          {
            categoryId: 4,
            categoryName: "经典阅读",
            hierarchy: 1,
            numberCourse: 12,
            sort: 1,
            children: [
              {
                categoryId: 41,
                categoryName: "绘本阅读",
                hierarchy: 2,
                numberCourse: 12,
                sort: 1,
              },
            ],
          },
          {
            categoryId: 5,
            categoryName: "研学实践",
            hierarchy: 1,
            numberCourse: 12,
            sort: 1,
          },
          {
            categoryId: 6,
            categoryName: "影视教育",
            hierarchy: 1,
            numberCourse: 12,
            sort: 1,
            children: [
              {
                categoryId: 61,
                categoryName: "名著导读",
                hierarchy: 2,
                numberCourse: 12,
                sort: 1,
                children: [
                  {
                    categoryId: 611,
                    categoryName: "个人传记",
                    hierarchy: 3,
                    numberCourse: 12,
                    sort: 1,
                  },
                  {
                    categoryId: 612,
                    categoryName: "历史传记",
                    hierarchy: 3,
                    numberCourse: 12,
                    sort: 1,
                  },
                ],
              },
            ],
          },
        ];
      }
    },
    //数据转树形结构
    totree(list, praId) {
      console.log(praId);

      let len = list.length;
      function loop(praId) {
        let res = [];
        for (let i = 0; i < len; i++) {
          let item = list[i];
          if (item.parentId == praId) {
            item.children = loop(item.categoryId);
            res.push(item);
          }
        }
        return res;
      }
      return loop(praId);
    },
    addCategory(i) {
      this.parentId = i.categoryId;
      this.addType = 0;
      let changeData = JSON.parse(JSON.stringify(this.tableData));
      let obj = {
        categoryId:
          i.children && i.children.length > 0
            ? i.children[i.children.length - 1].categoryId + 1
            : (i.categoryId + "1") * 1,
        categoryName: "",
        isAdd: true,
        hierarchy: i.hierarchy + 1,
        sort:
          i.children && i.children.length > 0
            ? i.children[i.children.length - 1].sort + 1
            : 1,
      };

      const datas = this.dealCategory(i.categoryId, changeData, obj);
      this.tableData = datas;
    },
    dealCategory(id, data, obj) {
      data.map((item, index) => {
        if (item.categoryId == id) {
          item.children ? item.children.push(obj) : (item.children = [obj]);
        } else {
          if (item.children) {
            this.dealCategory(id, item.children, obj);
          }
        }
      });
      return data;
    },
    editCategory(item) {
      this.$set(item, "isAdd", true);

      this.addType = 1;
    },
    //删除课程
    delCategory(item) {
      this.deleteCatgeory(this.tableData, item.categoryId);
      this.delCategoryAjax(item.categoryId);
    },
    deleteCatgeory(data, id) {
      console.log(data, id, "dwdwadwa");
      data.map((v, index) => {
        if (v.categoryId == id) {
          data.splice(index, 1);
        } else {
          if (data[index].children) {
            this.deleteCatgeory(v.children, id);
          }
        }
      });
    },
    async delCategoryAjax(categoryId) {
      let vm = this;
      util
        .handleCofirm("确定要删此分类吗?", "info")
        .then(async (res) => {
          var { result } = await educationApi.getFiveSportDel({ categoryId });
          if (result == "000000") {
            vm.$message({
              type: "success",
              message: "操作成功",
            });
            vm.getDataList();
          } else {
            vm.$message({
              type: "error",
              message: "操作失败",
            });
          }
        })
        .catch((err) => {
          console.log("err", err); // cancel
        });
      // let res = await educationApi.getFiveSportDel({ categoryId });
      // if (res.result == "000000") {
      //   this.$message({ type: "success", message: "删除成功" });
      //   this.getDataList(0);
      // }
    },
    //取消添加子分类
    cancelAdd(i) {
      // console.log(i);
      // let data = JSON.parse(JSON.stringify(this.tableData));
      // if (i.isSort) {
      //   i.isSort = false;
      // } else {
      //   i.isAdd = false;
      //   data.map((v, index) => {
      //     if (v.categoryId == i.categoryId) {
      //       data.splice(index, 1);
      //     } else {
      //       v.children?.map((item, n) => {
      //         if (item.categoryId == i.categoryId) {
      //           if (v.children.length > 1) {
      //             v.children.splice(n, 1);
      //           } else {
      //             delete v.children;
      //           }
      //         }
      //       });
      //     }
      //     this.tableData = data;
      //   });
      // }
      this.getDataList();
    },
    sortBtn(i) {
      this.$set(i, "isSort", true);
    },
    //保存子分类添加
    async confirmAdd(i) {
      i.isAdd = false;
      console.log(i);
      if (this.addType == 0) {
        let params = {
          categoryName: i.categoryName,
          parentId: this.parentId,
          sort: i.sort,
          hierarchy: i.hierarchy,
        };
        let res = await educationApi.getFiveSportAdd(params);
        if (res.result == "000000") {
          this.$message({ type: "success", message: "操作成功" });
          this.getDataList(0);
        }
      } else {
        let params = {
          categoryId: i.categoryId,
          categoryName: i.categoryName,
          sort: i.sort,
        };
        let res = await educationApi.getFiveSportEdit(params);
        if (res.result == "000000") {
          this.$message({ type: "success", message: "操作成功" });
          this.getDataList(0);
        } else {
          this.$message({ type: "error", message: res.desc });
        }
      }
    },
  },
  created() {
    this.getDataList(0);
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
